// extracted by mini-css-extract-plugin
export default {"container":"MonthCampaigns_container__dSW83","title":"MonthCampaigns_title__gE+jG"};